import type { RouteNamedMap } from "vue-router/auto-routes"
import { ref } from "vue"
import { useRoute } from "vue-router"

type RouteParams = Record<string, string>

export function useConvertedRouteParam<T = string>(paramName: string, routeName: keyof RouteNamedMap, convert?: (value: string) => T) {
  const route = useRoute()
  const routeParam = ref<T | undefined>()

  if (route.name === routeName) {
    const params = route.params as RouteParams

    if (convert) {
      const converted = convert(params[paramName])
      routeParam.value = (typeof converted === "number" && Number.isNaN(converted)) ? undefined : converted
    }
    else {
      routeParam.value = params[paramName] as T
    }
  }

  return routeParam
}

export function useRouteParam<K extends keyof RouteNamedMap>(paramName: string, routeName: K) {
  const route = useRoute()
  const paramValue = ref<number | undefined>()

  if (route.name === routeName) {
    const params = route.params as RouteParams

    const param = params[paramName]
    if (param) {
      const num = Number(param)
      paramValue.value = Number.isNaN(num) ? undefined : num
    }
  }

  return paramValue
}
